import config from "config";

import { isCodatUrl } from "./isCodatUrl";

export function sanitizeRedirect(url: string | undefined | null) {
  if (url) {
    const decodedUrl = decodeURIComponent(url);

    if (
      isCodatUrl(decodedUrl) ||
      (decodedUrl.charAt(0) === "/" && decodedUrl.charAt(1) !== "/")
    ) {
      return url;
    }

    return config.PORTAL_URL;
  }
  return undefined;
}
